import React, {Component} from 'react';

export default class AddressForm extends Component {
	constructor() {
		super();
	}

	render() {
		return (
			<div>
				{ this.props.customerStatus === "Upgrading" ? (
					<div>
						<label>Email</label>
			      <input
              type        = "email"
              onChange    = {this.props.handleChange.bind( this, 'email', 'customer' )}
              placeholder = "Email"
              value       = {this.props.customer.email}
              required    = "required" />
            <label>Password</label>
            <input
              type        = "password"
              onChange    = {this.props.handleChange.bind( this, 'password', 'customer' )}
              placeholder = "Password"
              value       = {this.props.customer.password}
              required    = "required" />
          </div>
					): (<div />)}
				{ this.props.upgradeFlow ? (
					<div>
						<label>First Name</label>
			      <input
			        type        = "text"
			        onChange    = {this.props.handleChange.bind( this, 'first_name', 'customer' )}
			        placeholder = "First Name"
			        value       = {this.props.customer.first_name}
			        required    = "required"
			        name="customer-name"
			        className   = {this.props.shipping_error && this.props.customer.first_name === null ? "error" : ""} />
			      <label>Last Name</label>
			      <input
			        type        = "text"
			        onChange    = {this.props.handleChange.bind( this, 'last_name', 'customer' )}
			        placeholder = "Last Name"
			        value       = {this.props.customer.last_name}
			        required    = "required"
			        name="customer-last-name"
			        className   = {((this.props.shipping_error && this.props.customer.last_name === null) ? "error" : "")} />
						</div>
					): (<div />)}
				<label>Address</label>
	      <input
	        type        = "text"
	        onChange    = {this.props.handleChange.bind( this, 'street', 'shipping_address' )}
	        placeholder = "Address"
	        value       = {this.props.shipping_address.street}
	        required    = "required"
	        name="ship-address"
	        className   = {((this.props.shipping_error && this.props.shipping_address.street === null) ? "error" : "")}
	      />
	      <label>City</label>
	      <input
	        type        = "text"
	        onChange    = {this.props.handleChange.bind( this, 'city', 'shipping_address' )}
	        placeholder = "City"
	        value       = {this.props.shipping_address.city}
	        required    = "required"
	        name="ship-city"
	        className   = {((this.props.shipping_error && this.props.shipping_address.city === null) ? "error" : "")}
	      />

	      <label>State</label>
	      <div className={"select-wrapper unselectable" + ((this.props.shipping_error && this.props.shipping_address.state === null) ? " error" : "")}>
	        <select
	          onChange     = {this.props.handleChange.bind( this, 'state', 'shipping_address' )}
	          required
	          name="ship-state"
	          defaultValue = {this.props.shipping_address.state || "State"}
	        >
	          <option value="State" disabled>State</option>
	          <option value="AA">AA - Armed Forces Americas</option>
	          <option value="AE">AE - Armed Forces Europe</option>
	          <option value="AK">AK - Alaska</option>
	          <option value="AL">AL - Alabama</option>
	          <option value="AP">AP - Armed Forces Pacific</option>
	          <option value="AR">AR - Arkansas</option>
	          <option value="AZ">AZ - Arizona</option>
	          <option value="CA">CA - California</option>
	          <option value="CO">CO - Colorado</option>
	          <option value="CT">CT - Connecticut</option>
	          <option value="DC">DC - District of Columbia</option>
	          <option value="DE">DE - Delaware</option>
	          <option value="FL">FL - Florida</option>
	          <option value="GA">GA - Georgia</option>
	          <option value="HI">HI - Hawaii</option>
	          <option value="IA">IA - Iowa</option>
	          <option value="ID">ID - Idaho</option>
	          <option value="IL">IL - Illinois</option>
	          <option value="IN">IN - Indiana</option>
	          <option value="KS">KS - Kansas</option>
	          <option value="KY">KY - Kentucky</option>
	          <option value="LA">LA - Lousiana</option>
	          <option value="MA">MA - Massachusetts</option>
	          <option value="MD">MD - Maryland</option>
	          <option value="ME">ME - Maine</option>
	          <option value="MI">MI - Michigan</option>
	          <option value="MN">MN - Minnesota</option>
	          <option value="MO">MO - Missouri</option>
	          <option value="MS">MS - Mississippi</option>
	          <option value="MT">MT - Montana</option>
	          <option value="NC">NC - North Carolina</option>
	          <option value="ND">ND - North Dakota</option>
	          <option value="NE">NE - Nebraska</option>
	          <option value="NH">NH - New Hampshire</option>
	          <option value="NJ">NJ - New Jersey</option>
	          <option value="NM">NM - New Mexico</option>
	          <option value="NV">NV - Nevada</option>
	          <option value="NY">NY - New York</option>
	          <option value="OH">OH - Ohio</option>
	          <option value="OK">OK - Oklahoma</option>
	          <option value="OR">OR - Oregon</option>
	          <option value="PA">PA - Pennsylvania</option>
	          <option value="PR">PR - Puerto Rico</option>
	          <option value="RI">RI - Rhode Island</option>
	          <option value="SC">SC - South Carolina</option>
	          <option value="SD">SD - South Dakota</option>
	          <option value="TN">TN - Tennessee</option>
	          <option value="TX">TX - Texas</option>
	          <option value="UT">UT - Utah</option>
	          <option value="VA">VA - Virginia</option>
	          <option value="VT">VT - Vermont</option>
	          <option value="WA">WA - Washington</option>
	          <option value="WI">WI - Wisconsin</option>
	          <option value="WV">WV - West Virginia</option>
	          <option value="WY">WY - Wyoming</option>
	        </select>
	      </div>
	      <label>Zipcode</label>
	      <input
	        type        = "text"
	        onChange    = {this.props.handleChange.bind( this, 'zip', 'shipping_address' )}
	        placeholder = "Zip code"
	        value       = {this.props.shipping_address.zip}
	        required    = "required"
	        name="ship-zip"
	        className   = {((this.props.shipping_error && this.props.shipping_address.zip === null) ? "error" : "")} />
	    </div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/AddressForm.jsx